var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('brace',{staticStyle:{"height":"90vh","width":"100vw"},attrs:{"mode":'text'},on:{"code-change":_vm.onEditorCodeChange,"setHandler":function (h) {
					_vm.editorHandler = h;
				}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }